// Returns today's date as YYYY-MM-DD in US Eastern time, regardless of device timezone.
export const getEasternToday = () =>
  new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });

// Returns current time string (e.g. "3:45 PM") in US Eastern time.
export const getEasternTimeString = () =>
  new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'America/New_York' });
